import React, {useState, useContext, useRef, useEffect} from 'react';
import { IonContent, IonText, IonHeader, IonImg, IonTitle, IonToolbar, IonItem, IonList, IonMenuButton, IonButton, IonButtons, IonInput, IonModal, IonGrid, IonRow, IonCol, IonDatetime, IonFooter } from '@ionic/react';
import { IonSlides, IonSlide, IonLabel } from '@ionic/react';

import { EnterPasswordModal } from '../../../zInternal_Features/merchant/components/Modal_EnterPassword';
import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

import { TakePhoto, photos } from '../../../zInternal_Features/merchant/components/TakePhoto';

import '../../../../css/qavaApp.css';
import '../../../zPublic/css/zPublic.css'

export function CreateInventoryProductModal (props) {

    //alert('inside CreateEmployeeModal');
    //alert(props.openModal);

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    const [acctID, setAcctID] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [accessRights, setAccessRights ] = useState(authenticatedMerchent_context.accessRights);


    let [selectedFile, setSelectedFile] = useState(null);

    let [productID, setProductID] = useState(null);
    let [productDateCreated, setProductDateCreated] = useState(null);
    let [productPic1, setProductPic1] = useState(null);
    let [productPic2, setProductPic2] = useState(null);
    let [productPic3, setProductPic3] = useState(null);
    let [productPic4, setProductPic4] = useState(null);

    let [takePhotoStatus1, setTakePhotoStatus1] = useState(false);
    let [takePhotoStatus2, setTakePhotoStatus2] = useState(false);
    let [takePhotoStatus3, setTakePhotoStatus3] = useState(false);
    let [takePhotoStatus4, setTakePhotoStatus4] = useState(false);

    let [productPicsModal, setProductPicsModal] = useState(false);

    let [productImageNumber, setProductImageNumber] = useState(null);

    let [showPasswordModal, setShowPasswordModal] = useState(false);

    let [row_1, setRow_1] = useState(false);
    let [row_2, setRow_2] = useState(false);
    let [row_3, setRow_3] = useState(false);
    let [row_4, setRow_4] = useState(false);
    let [row_5, setRow_5] = useState(false);
    let [row_6, setRow_6] = useState(false);
    let [row_7, setRow_7] = useState(false);
    let [row_8, setRow_8] = useState(false);
    let [row_9, setRow_9] = useState(false);



    // let createProductAddition_type = useRef(props.data.addition_type);
    // let createProductTypeRef = useRef(props.data.itemType);
    // let createProductDescriptionRef = useRef(props.data.itemDescription);
    // let createProductPartNumRef = useRef(props.data.vendorPartNum);
    // let createProductPhoneNumberRef = useRef(props.data.vendorPartNum);
    // let createProductAddressRef = useRef(props.data.vendorAddress);
    // let createProductCityRef = useRef(props.data.vendorCity);
    // let createProductCountryRef = useRef(props.data.vendorCountry);
    // let createProductCostPerUnitRef = useRef(props.data.costPerUnit);
    // let createProductSalePriceRef = useRef(props.data.salePrice);
    // let createProductQtyInUse = useRef(props.data.qtyInUse);
    // let createProductDateCreated = useRef(props.data.dateCreated);
    // let createProductAddedBy = useRef(props.data.addedBy);


    let [createProductAddition_type, setCreateProductAddition_type] = useState(props.data.addition_type);

    let [createProductType, setCreateProductType] = useState(props.data.addition_type);
    let [createProductItemType, setCreateProductItemType] = useState(props.data.itemType);
    let [createProductDescription, setCreateProductDescription] = useState(props.data.itemDescription);
    let [createProductPartNum, setCreateProductPartNum] = useState(props.data.vendorPartNum);
    let [createProductPhoneNumber, setCreateProductPhoneNumber] = useState(props.data.vendorPhoneNumber);
    let [createProductAddress, setCreateProductAddress] = useState(props.data.vendorAddress);
    let [createProductCity, setCreateProductCity] = useState(props.data.vendorCity);
    let [createProductCountry, setCreateProductCountry] = useState(props.data.vendorCountry);
    let [createProductCostPerUnit, setCreateProductCostPerUnit] = useState(props.data.costPerUnit);
    let [createProductSalePrice, setCreateProductSalePrice] = useState(props.data.salePrice);
    let [createProductQtyInUse, setCreateProductQtyInUse] = useState(props.data.qtyInUse);
    let [createProductDateCreated, setCreateProductDateCreated] = useState(props.data.dateCreated);
    let [createProductAddedBy, setCreateProductAddedBy] = useState(props.data.addedBy); 


    function selectedFileHandler1(event)
    {

        alert("in Photo");
        alert(event);

        setProductImageNumber("1");
        setProductPic1(event);
        setTakePhotoStatus1(false);
    }

    function selectedFileHandler2(event)
    {
        setProductImageNumber("2");
        setProductPic2(event);
        setTakePhotoStatus2(false);
    }
    function selectedFileHandler3(event)
    {
        setProductImageNumber("3");
        setProductPic3(event);
        setTakePhotoStatus3(false);
    }
    function selectedFileHandler4(event)
    {
        setProductImageNumber("4");
        setProductPic4(event);
        setTakePhotoStatus4(false);
    }


    function handle_no_attachement(event) {  

        fetch(baseURL+'fileServer/merchants/image-not-available.jpeg')
        .then(res => res.blob())
        .then(data => {

            const blobUrl = URL.createObjectURL(data);

            let noImageFile = new File([data], blobUrl, {
                enctype: 'multipart/form-data',
                type: 'image/jpeg',
                name: 'xImageFile',
                accept: "image/*",
            });
            
            setProductImageNumber(event[0]);
            setProductPic1(noImageFile);
            setProductPic2(noImageFile);
            setProductPic3(noImageFile);
            setProductPic4(noImageFile);

            alert("No Product Pics Option checked");

        })
    }


    function uploadRoomImage()
    {
    
        let formData = new FormData();
        formData.append('Tracker', '74300_Pic_retail');
        formData.append('user', acctID);
        formData.append('xInventoryRoomID', props.data.roomID);
        formData.append('xProductImageNumber', productImageNumber);
        formData.append('xImageFile', selectedFile);
        formData.append('xEnterAdminPassword', accessRights[0]);
        formData.append('sessionID', sessionID);


        const requestOptions = {
            enctype: 'multipart/form-data',
            method: 'POST',
            //credentials: 'include',
            file: formData,
            body: formData,
            contentType: false,
            processData: false,

            
            // body: JSON.stringify({
            //     Tracker: '74300_Pic',
            //     user: acctID,
            //     xInventoryRoomID: props.data.roomID,
            //     xProductImageNumber: productImageNumber,
            //     xImageFile: selectedFile,
            //     xEnterAdminPassword: enteredPassword,
            //     sessionID: sessionID,

            // }),
        }

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);

            props.closeModal(false);

        })
        .catch(error => {
            console.error(error);
        })
    }



    function createProduct(adminPassword)
    {
        
        
        alert("In Crate Product Function");
       alert(schema);
       //alert(createProductPartNum);
       //alert(createProductPhoneNumber);
       //alert(createProductCostPerUnit);
       // alert(pic4.value);
       //alert(totalProductPics);

        
        let formData = new FormData();
        //formData.append('xProductPics', totalProductPics);
        //formData.append('xProductPics', [ProductPic1, ProductPic2, ProductPic3, ProductPic3]);
        formData.append('Tracker', '74300_retail');
        formData.append('user', acctID);
        formData.append('merchantSchema', schema);
        formData.append('xInventoryProductType', createProductType);
        formData.append('xInventoryProductDescription', createProductDescription);
        formData.append('xInventoryProductPartNum', createProductPartNum);
        formData.append('xInventoryProductPhoneNumber', createProductPhoneNumber);
        formData.append('xInventoryProductAddress', createProductAddress);
        formData.append('xInventoryProductCity', createProductCity);
        formData.append('xInventoryProductCountry', createProductCountry);
        formData.append('xInventoryProductCostPerUnit', createProductCostPerUnit);
        formData.append('xInventoryProductSalePrice', createProductSalePrice);
        formData.append('xSupportingDocumentation', selectedFile);
        formData.append('xEnterAdminPassword', adminPassword);
        formData.append('xStorefront', props.data.storefront);
        formData.append('sessionID', sessionID);
        formData.append('xPic1', productPic1);
        formData.append('xPic2', productPic2);
        formData.append('xPic3', productPic3);
        formData.append('xPic4', productPic4);


        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            //credentials: 'include',
            file: formData,
            body: formData,
            contentType: false,
            processData: false,
        }
        


        fetch(baseURL+'retail_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);
        })
        .catch(error => {
            console.error(error);
        })

        props.closeModal(false)
    }


    function saveUploadedFile(event) {
    
        //alert(event);
        
        if(event.target.files === null)
        {
            //selectedFile = "/home/tkweifio/Documents/LocalKuaye/Forms/web/Public/fileServer/merchants/image-not-available.jpg";
            setSelectedFile("/home/tkweifio/Documents/LocalKuaye/Forms/web/Public/fileServer/merchants/image-not-available.jpg")

        }
        else
        {
            //selectedFile = event.target.files[0];
            setSelectedFile(event.target.files[0]);
        }


    }

    function saveProductPictures(event) { 

        setProductPic1(event.target.files[0]);
        setProductPic2(event.target.files[1]);
        setProductPic3(event.target.files[2]);
        setProductPic4(event.target.files[3]);
    
    
    }


    function handleFileChange(event) {

        //alert("in HadndleFileChange");
        //alert(event.target.dataset.id);
        // alert(event.target);
        // alert(event.target.files);
        // alert(event.target.files[0]);

        if(event[0] = "1")
        {
            const file = event[1].target.files ? event[1].target.files[0] : null;
            setProductImageNumber(event[1].target.dataset.id);
            setProductPic1(file);
        }
        if(event[0] = "2")
        {
            const file = event[1].target.files ? event[1].target.files[0] : null;
            setProductImageNumber(event[1].target.dataset.id);
            setProductPic2(file);
        }
        if(event[0] = "3")
        {
            const file = event[1].target.files ? event[1].target.files[0] : null;
            setProductImageNumber(event[1].target.dataset.id);
            setProductPic3(file);
        }
        if(event[0] = "4")
        {
            const file = event[1].target.files ? event[1].target.files[0] : null;
            setProductImageNumber(event[1].target.dataset.id);
            setProductPic4(file);
        }
    }

    function onSubmitPasswordHandler(enteredPassword)
    {
        alert('In onSubmitPasswordHandler');

        //setEnteredPassword(event);
        createProduct(enteredPassword);
    }

    function closeModalHandler() {

        props.closeModal(false);
    }

    useEffect(() => {

        setSelectedFile("/home/tkweifio/Documents/LocalKuaye/Forms/web/Public/fileServer/merchants/image-not-available.jpg");
        handle_no_attachement();

    }, [])
    
    //alert("IN CREATE PRODUCT")

    return (
        <React.Fragment>
        {props.openModal == true ?
        (
        <IonModal isOpen={ props.openModal }>
             <IonContent className='bookedDetails_gridContent_multiple'>

            <IonSlides pager='true'>
                <IonSlide>
                    <IonGrid>
                        <IonRow>
                            <IonCol>
                                <IonLabel for="ProductType">Product Type </IonLabel>
                            </IonCol>
                            <IonCol>
                                    <select name="productType" id='productType' onChange={(e) => setCreateProductType(e.detail.value)}>
                                        <option value='std'>Standard</option>
                                        <option value='dlx'>Deluxe</option>
                                        <option value='exec'>Executive</option>
                                    </select>
                            </IonCol>
                        </IonRow>
                        <IonRow> 
                            <IonCol>
                                <IonLabel>Product Description: </IonLabel>
                            </IonCol>
                            <IonCol>
                                {row_2 == true && <IonInput placeholder='Enter Product Description'  onIonChange={(e) => setCreateProductDescription(e.detail.value)}></IonInput>}
                                {row_2 == false && <IonText>{createProductDescription} </IonText>}
                            </IonCol>
                            {row_2 == false && <IonCol>
                                <IonButton onClick={() => setRow_2(true)}>Update</IonButton>
                            </IonCol>}
                            {row_2 == true && <IonCol>
                                <IonButton onClick={() => setRow_2(false)}>Confirm</IonButton>
                            </IonCol>}
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <IonLabel>Product Part Number: </IonLabel>
                            </IonCol>
                            <IonCol>
                                {row_3 == true && <IonInput placeholder='Enter Product Description' onIonChange={(e) => setCreateProductPartNum(e.detail.value)}></IonInput>}
                                {row_3 == false && <IonText>{createProductPartNum}</IonText>}
                            </IonCol>
                            {row_3 == false && <IonCol>
                                <IonButton onClick={() => setRow_3(true)}>Update</IonButton>
                            </IonCol>}
                            {row_3 == true && <IonCol>
                                <IonButton onClick={() => setRow_3(false)}>Confirm</IonButton>
                            </IonCol>}
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <IonLabel>Product Phone Number: </IonLabel>
                            </IonCol>
                            <IonCol>
                                {row_4 == true && <IonInput placeholder='Enter Product Phone Number' onIonChange={(e) => setCreateProductPhoneNumber(e.detail.value)}></IonInput>}
                                {row_4 == false && <IonText>{createProductPartNum}</IonText>}
                            </IonCol>
                            {row_4 == false && <IonCol>
                                <IonButton onClick={() => setRow_4(true)}>Update</IonButton>
                            </IonCol>}
                            {row_4 == true && <IonCol>
                                <IonButton onClick={() => setRow_4(false)}>Confirm</IonButton>
                            </IonCol>}
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <IonLabel>Product Address: </IonLabel>
                            </IonCol>
                            <IonCol>
                                {row_5 == true && <IonInput placeholder='Enter Product Address' onIonChange={(e) => setCreateProductAddress(e.detail.value)}></IonInput>}
                                {row_5 == false && <IonText >{createProductAddress}</IonText>}
                            </IonCol>
                            {row_5 == false && <IonCol>
                                <IonButton onClick={() => setRow_5(true)}>Update</IonButton>
                            </IonCol>}
                            {row_5 == true && <IonCol>
                                <IonButton onClick={() => setRow_5(false)}>Confirm</IonButton>
                            </IonCol>}
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <IonLabel>Product City: </IonLabel>
                            </IonCol>
                            <IonCol>
                                {row_6 == true && <IonInput placeholder='Enter Product City' onIonChange={(e) => setCreateProductCity(e.detail.value)}></IonInput>}
                                {row_6 == false && <IonText >{createProductCity}</IonText>}
                            </IonCol>
                            {row_6 == false && <IonCol>
                                <IonButton onClick={() => setRow_6(true)}>Update</IonButton>
                            </IonCol>}
                            {row_6 == true && <IonCol>
                                <IonButton onClick={() => setRow_6(false)}>Confirm</IonButton>
                            </IonCol>}
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <IonLabel>Product Country: </IonLabel>
                            </IonCol>
                            <IonCol>
                                {row_7 == true && <IonInput placeholder='Enter Product Country' onIonChange={(e) => setCreateProductCountry(e.detail.value)}></IonInput>}
                                {row_7 == false && <IonText >{createProductCountry}</IonText>}
                            </IonCol>
                            {row_7 == false && <IonCol>
                                <IonButton onClick={() => setRow_7(true)}>Update</IonButton>
                            </IonCol>}
                            {row_7 == true && <IonCol>
                                <IonButton onClick={() => setRow_7(false)}>Confirm</IonButton>
                            </IonCol>}
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <IonLabel>Product Cost Per Unit: </IonLabel>
                            </IonCol>
                            <IonCol>
                                {row_8 == true && <IonInput placeholder='Enter Product Cost Per Unit' onIonChange={(e) => setCreateProductCostPerUnit(e.detail.value)}></IonInput>}
                                {row_8 == false && <IonText >{createProductCostPerUnit}</IonText>}
                            </IonCol>
                            {row_8 == false && <IonCol>
                                <IonButton onClick={() => setRow_8(true)}>Update</IonButton>
                            </IonCol>}
                            {row_8 == true && <IonCol>
                                <IonButton onClick={() => setRow_8(false)}>Confirm</IonButton>
                            </IonCol>}
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <IonLabel>Product Sale Price: </IonLabel>
                            </IonCol>
                            <IonCol>
                                {row_9 == true && <IonInput placeholder='Enter Product Sale Price' onIonChange={(e) => setCreateProductSalePrice(e.detail.value)}></IonInput>}
                                {row_9 == false && <IonText >{createProductSalePrice}</IonText>}
                            </IonCol>
                            {row_9 == false && <IonCol>
                                <IonButton onClick={() => setRow_9(true)}>Update</IonButton>
                            </IonCol>}
                            {row_9 == true && <IonCol>
                                <IonButton onClick={() => setRow_9(false)}>Confirm</IonButton>
                            </IonCol>}
                        </IonRow>
                    </IonGrid>
                </IonSlide>
                <IonSlide>
                    <IonGrid  class='BusinessTabSlideGrid'>
                        <IonRow>
                            <IonCol> 1/4 </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <IonImg src={props.data.roomPic1}></IonImg>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>                            
                                <IonButton  onClick={() => setTakePhotoStatus1(true)}> Take Photo</IonButton>
                                {takePhotoStatus1 == true && <TakePhoto onSelectedFile={selectedFileHandler1}></TakePhoto>}
                            </IonCol>
                            <IonCol>
                                <input
                                    type="file"
                                    accept="image/jpeg"
                                    data-id='1'
                                    onChange={(e) => handleFileChange(["1", e])}
                                />
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <label for='noAttachment'>No Attachment</label>
                            </IonCol>
                            <IonCol>
                                <input type='checkbox' id='noAttachment' onClick={() => handle_no_attachement(['1'])}></input>
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                </IonSlide>
                <IonSlide>
                    <IonGrid  class='BusinessTabSlideGrid'>
                        <IonRow>
                            <IonCol> 2/4 </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <IonImg src={props.data.roomPic2}></IonImg>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>                            
                                <IonButton  onClick={() => setTakePhotoStatus2(true)}> Take Photo</IonButton>
                                {takePhotoStatus2 == true && <TakePhoto onSelectedFile={selectedFileHandler2}></TakePhoto>}
                            </IonCol>
                            <IonCol>
                                <input
                                    type="file"
                                    accept="image/jpeg"
                                    data-id='2'
                                    onChange={(e) => handleFileChange(["2", e])}
                                />
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <label for='noAttachment'>No Attachment</label>
                            </IonCol>
                            <IonCol>
                                <input type='checkbox' id='noAttachment' onClick={() => handle_no_attachement(['2'])}></input>
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                </IonSlide>
                <IonSlide>
                    <IonGrid  class='BusinessTabSlideGrid'>
                        <IonRow>
                            <IonCol> 3/4 </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <IonImg src={props.data.roomPic3}></IonImg>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>                            
                                <IonButton  onClick={() => setTakePhotoStatus3(true)}> Take Photo</IonButton>
                                {takePhotoStatus3 == true && <TakePhoto onSelectedFile={selectedFileHandler3}></TakePhoto>}
                            </IonCol>
                            <IonCol>
                                <input
                                    type="file"
                                    accept="image/jpeg"
                                    data-id='3'
                                    onChange={(e) => handleFileChange(["3", e])}
                                />
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <label for='noAttachment'>No Attachment</label>
                            </IonCol>
                            <IonCol>
                                <input type='checkbox' id='noAttachment' onClick={() => handle_no_attachement(['3'])}></input>
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                </IonSlide>
                <IonSlide>
                    <IonGrid  class='BusinessTabSlideGrid'>
                        <IonRow>
                            <IonCol> 4/4 </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <IonImg src={props.data.roomPic4}></IonImg>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>                            
                                <IonButton  onClick={() => setTakePhotoStatus4(true)}> Take Photo</IonButton>
                                {takePhotoStatus4 == true && <TakePhoto onSelectedFile={selectedFileHandler4}></TakePhoto>}
                            </IonCol>
                            <IonCol>
                                <input
                                    type="file"
                                    accept="image/jpeg"
                                    data-id='4'
                                    onChange={(e) => handleFileChange(["4", e])}
                                />
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <label for='noAttachment'>No Attachment</label>
                            </IonCol>
                            <IonCol>
                                <input type='checkbox' id='noAttachment' onClick={() => handle_no_attachement(['4'])}></input>
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                </IonSlide>
            </IonSlides>

            <EnterPasswordModal openModal={ showPasswordModal } closeModal={() => setShowPasswordModal(false)} onSubmitPassword={ onSubmitPasswordHandler }></EnterPasswordModal>
        </IonContent>
        <IonFooter class='appFooter'>
                <IonGrid>
                    <IonRow>
                        <IonCol>
                            <IonButton onClick={() => setShowPasswordModal(true)}> Confirm Product Creation </IonButton>
                        </IonCol>
                        <IonCol>
                            <IonButton onClick={() => closeModalHandler()}>Cancel </IonButton>
                        </IonCol>
                    </IonRow>
                </IonGrid>
        </IonFooter>
        </IonModal>
        ) : null}
        </React.Fragment>
        )
}